import { render, staticRenderFns } from "./TrackerDataTableItemDialogEdit.html?vue&type=template&id=c1e5d8cc&external"
import script from "./TrackerDataTableItemDialogEdit.js?vue&type=script&lang=js&external"
export * from "./TrackerDataTableItemDialogEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
